import { createReducer, on } from '@ngrx/store';
import {
  loadBranchCodesFailure,
  loadBranchCodesSuccess,
  toggleBranchCodesLoading,
} from './branch-codes.actions';
import { initialUIState } from './branch-codes.state';

export const branchCodesReducer = createReducer(
  initialUIState,
  on(loadBranchCodesSuccess, (state, { branchPartners }) => ({
    ...state,
    list: branchPartners,
  })),
  on(loadBranchCodesFailure, (state) => ({
    ...state,
    list: [],
  })),
  on(toggleBranchCodesLoading, (state, { loading }) => ({
    ...state,
    loading,
  })),
);
